<template>
  <div
    class="display-template-multi-default"
    :class="{
      'small': !tall
    }"
  >
    <p4a-icon
      class="empty-icon"
      v-if="leftIcon && noSelection"
      :icon="leftIcon"
      :color="'#dddddd'"
    />

    <span
      class="search-placeholder"
      v-if="noSelection"
      v-text="placeHolder"
    />

    <div
      class="tray-tag-container"
      v-if="!noSelection"
    >
      <tray-tag
        v-for="valueItem in valueList"
        :key="valueItem.Index"
        :display-key="displayKey"
        :display-object="valueItem"
        @clicked="optionSelected(valueItem)"
      />
    </div>
  </div>
</template>

<script>
  import * as _ from 'lodash'

  import TrayTag from '../../../../../components/SelectionTray/TrayTag'

  export default {
    name: 'DisplayTemplateMultiDefault',
    components: {
      'tray-tag': TrayTag
    },
    data () {
      return {
      }
    },
    props: {
      value: {
        default: function () {
          return []
        },
        type: Array
      },
      settings: {
        default: function () {
          return {
            displayKey: '',
            displayColor: false,
            colorKey: '',
            leftIcon: ''
          }
        },
        type: Object
      },
      disabled: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      optionSelected (value) {
        let self = this
        self.$emit('optionSelected', value)
      }
    },
    computed: {
      valueList () {
        let self = this
        return self.value
      },
      selectionHeight () {
        return this.tall ? 50 : 28
      },
      tall () {
        let self = this
        return self.settings.tall
      },
      displayColor () {
        let self = this
        return self.settings.displayColor
      },
      colorValue () {
        let self = this
        let result = null
        if (self.value && self.settings.colorKey) {
          result = '#' + self.value[self.settings.colorKey]
        }
        return result
      },
      displayKey () {
        let self = this
        return self.settings.displayKey
      },
      placeHolder () {
        let self = this
        return self.settings.placeHolder
      },
      leftIcon () {
        let self = this
        return self.settings.leftIcon
      },
      noSelection () {
        let self = this
        return _.size(self.valueList) === 0
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../../../uikit';

  %scrollbar-settings {
    display: none;
    width: 0 !important;
    height: 0 !important;
  }

  .display-template-multi-default {
    height: 100%;

    .empty-icon {
      display: inline-block;
      vertical-align: middle;
      height: 40%;
      width: 50px;
    }

    .search-placeholder {
      display: inline-block;
      font-size: 14px;
      height: 20px;
      line-height: 20px;
      max-width: calc(100% - 50px);
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      white-space: nowrap;
      color: $lightGreyFont;
      padding-left: 10px;
    }

    .tray-tag-container {
      display: inline-flex;
      overflow-x: auto;
      overflow-y: hidden;
      padding: 5px 10px;
      max-width: 100%;

      &::-webkit-scrollbar {
        @extend %scrollbar-settings;
      }

      .tray-tag {
        margin: 0 5px 0 0;
        max-width: 80px;
      }
    }

    &.small {

      .search-placeholder {
        max-width: calc(100% - 25px);
      }

      .empty-icon {
        width: 25px;
      }
    }

    /* add invisble scrollbar here later */
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/input-templates/selection/display-templates/default/DisplayTemplateMultiDefault.vue